module.exports = __webpack_public_path__ + "img/doc.bc5f9db1.svg";